import { createReducer, on } from '@ngrx/store';
import * as ExternalNotificationActions from './external-notification.actions';
import { ExternalNotificationState, initialExternalNotificationState } from './external-notification.state';

export const externalNotificationReducer = createReducer(
  initialExternalNotificationState,

  // Load notifications
  on(
    ExternalNotificationActions.loadNotifications,
    (state): ExternalNotificationState => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),

  on(ExternalNotificationActions.loadNotificationsSuccess, (state, { response }): ExternalNotificationState => {
    const notifications = response.result?.items || [];
    const meta = response.result?.meta;
    const pagination = {
      currentPage: meta?.page || 1,
      pageSize: meta?.size || 15,
      totalItems: meta?.count || 0,
      totalPages: Math.ceil((meta?.count || 0) / (meta?.size || 15)),
    };

    return {
      ...state,
      notifications,
      pagination,
      loading: false,
      error: null,
    };
  }),

  on(
    ExternalNotificationActions.loadNotificationsFailure,
    (state, { error }): ExternalNotificationState => ({
      ...state,
      loading: false,
      error,
    }),
  ),

  // Filter actions
  on(ExternalNotificationActions.setFilter, (state, { filter }): ExternalNotificationState => {
    return {
      ...state,
      loading: true,
      filter,
    };
  }),

  on(ExternalNotificationActions.clearFilter, (state): ExternalNotificationState => {
    return {
      ...state,
      filter: initialExternalNotificationState.filter,
    };
  }),

  on(ExternalNotificationActions.updatePagination, (state, { page, pageSize }): ExternalNotificationState => {
    return {
      ...state,
      loading: true,
      pagination: {
        ...state.pagination,
        currentPage: page,
        pageSize: pageSize,
      },
    };
  }),
);
